<!--suppress JSUnresolvedVariable -->
<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">
            新闻管理
          </span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <el-button
          @click="addNews(0)"
          size="small"
          type="primary"
          plain
          :disabled="!adminPermissions.includes('/news/admin/addOrUpdateNews')"
        >
          新增新闻
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="newsList"
        tooltip-effect="dark"
        stripe
        height="417"
        style="width: 100%;"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column prop="newsId" label="新闻ID" sortable align="center">
        </el-table-column>
        <el-table-column prop="newsTitle" label="新闻标题"></el-table-column>
        <el-table-column
          prop="newsViews"
          sortable
          label="浏览量"
          align="center"
        >
        </el-table-column>
        <el-table-column label="状态" align="center" width="170">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.newsStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="已发布"
              inactive-text="未发布"
              :disabled="
                !adminPermissions.includes('/news/admin/addOrUpdateNews')
              "
              @change="value => newsStatusChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="首页显示" align="center" width="138">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.homeShow"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              :disabled="
                !adminPermissions.includes('/news/admin/addOrUpdateNews')
              "
              @change="value => isHomeShowChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="publishTime"
          sortable
          label="发布时间"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column label="标签" prop="newsTag" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.newsTag === 0">无</el-tag>
            <el-tag type="danger" v-if="scope.row.newsTag === 1">hot</el-tag>
            <el-tag type="success" v-if="scope.row.newsTag === 2">置顶</el-tag>
            <el-tag type="warning" v-if="scope.row.newsTag === 3">推荐</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="keywordSearch"
              size="mini"
              placeholder="输入关键字,按回车开始搜索"
              @keyup.enter.native="startSearch(scope)"
            />
          </template>
          <template slot-scope="scope">
            <el-button
              @click="editNewsInfo(scope.row.newsId)"
              type="primary"
              plain
              size="small"
              :disabled="
                !adminPermissions.includes('/news/admin/addOrUpdateNews')
              "
              >编辑
            </el-button>

            <el-button
              type="danger"
              slot="reference"
              plain
              @click="deleteNewsById(scope.row.newsId)"
              size="small"
              :disabled="!adminPermissions.includes('/news/admin/deleteNews')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt-3"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "NewsList",
  data() {
    return {
      newsList: [],
      adminPermissions: this.$store.state.adminPermissions,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      keywordSearch: ""
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      this.loading = true;
      this.axios
        .get("/news/admin/getNewsList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.newsList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    startSearch() {
      this.loading = true;
      this.axios
        .get("/news/getNewsByKeyword", {
          params: {
            currentPage: 1,
            pageSize: this.pageSize,
            keyword: this.keywordSearch
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.newsList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getNewsList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getNewsList();
    },
    newsStatusChange(status, news) {
      this.axios
        .post("/news/admin/addOrUpdateNews", {
          newsId: news.newsId,
          newsStatus: status,
          homeShow: news.homeShow
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (status) {
              this.$notify({
                title: "成功",
                message: "新闻发布成功",
                type: "success"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "新闻撤销成功",
                type: "success"
              });
            }
          }
        });
    },
    isHomeShowChange(value, news) {
      this.axios
        .post("/news/homeShowChange", {
          newsId: news.newsId,
          newsStatus: news.newsStatus,
          homeShow: value
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (value) {
              this.$notify({
                title: "成功",
                message: "已设置为首页显示",
                type: "success"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "已取消首页显示",
                type: "success"
              });
            }
          }
        });
    },
    editNewsInfo(newsId) {
      this.$router
        .push({ name: "NewsForm", params: { newsId: newsId } })
        .catch();
    },
    addNews(newsId) {
      this.$router
        .push({ name: "NewsForm", params: { newsId: newsId } })
        .catch();
    },
    deleteNewsById(newsId) {
      this.$confirm("此操作将永久删除该新闻, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .delete("/news/admin/deleteNews", {
              params: {
                newsId: newsId
              }
            })
            .then(resp => {
              if (resp && resp.data.code === 10000 && resp.data.success) {
                this.getNewsList();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped></style>
